var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Absolute, Box, Relative } from 'pcln-design-system';
import { CircleLarge, PricelineP } from '../svg-build';
import { ImageContainer } from './ImageContainer';
/** @public */
export var Stage = styled(Relative).attrs({
    minHeight: ['268px', null, null, '330px', '576px'],
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-y: clip;\n  ", " {\n    overflow-y: unset;\n  }\n"], ["\n  overflow-y: clip;\n  ", " {\n    overflow-y: unset;\n  }\n"
    /** @public */
])), themeGet('mediaQueries.xl'));
/** @public */
export var YellowOrb = styled(Box).attrs({
    size: '200px',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n"
    /** @public */
])));
/** @public */
export var StyledP = styled(function (props) { return React.createElement(PricelineP, __assign({}, props)); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  ", "\n\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"
    /** @public */
])), function (_a) {
    var mirror = _a.mirror;
    return (mirror === 'left' ? 'transform: scaleX(-1);' : '');
});
/** @public */
export var StyledCircleLarge = styled(CircleLarge)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"
    /** @public */
])));
/** @public */
export var CircleStage = styled(Absolute)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  z-index: 3;\n\n  ", " {\n    z-index: 1;\n  }\n"], ["\n  z-index: 3;\n\n  ", " {\n    z-index: 1;\n  }\n"
    /** @public */
])), themeGet('mediaQueries.lg'));
/** @public */
export var PStage = styled(Absolute)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  z-index: 2;\n"], ["\n  z-index: 2;\n"
    /** @public */
])));
/** @public */
export var props = {
    className: PropTypes.string,
    imageUrl: PropTypes.node,
    mirror: PropTypes.oneOf(['left', 'right']),
    imageClassName: PropTypes.string,
};
/** @public */
var Silhouette = function (_a) {
    var mirror = _a.mirror, imageUrl = _a.imageUrl, className = _a.className, imageClassName = _a.imageClassName;
    var SPHERE_OFFSET = ['-30%', '-20%', null, null, '-70%', '-45%'];
    var sphereProps = mirror === 'left' ? { left: SPHERE_OFFSET } : { right: SPHERE_OFFSET };
    var P_OFFSET = ['-45%', null, '-28%', '-35%', '-15%', '-20%'];
    var pProps = mirror === 'left' ? { right: P_OFFSET, transform: 'scaleX(-1)' } : { left: P_OFFSET };
    return (React.createElement(Stage, { className: className },
        React.createElement(CircleStage, __assign({ width: ['340px', null, '458px', null, '576px'], bottom: '0' }, sphereProps),
            React.createElement(StyledCircleLarge, null)),
        React.createElement(PStage, __assign({ width: ['412px', null, null, '640px', '115%'], top: ['-70%', null, '-75%', '-100%', '-60%', '-70%'] }, pProps),
            React.createElement(StyledP, { mirror: mirror })),
        React.createElement(ImageContainer, { mirror: mirror, imageUrl: imageUrl, imageClassName: imageClassName })));
};
Silhouette.propTypes = props;
Silhouette.defaultProps = {
    mirror: 'right',
};
/** @public */
export { Silhouette };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Silhouette.js.map